var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box gauge--1"},[_c('div',{staticClass:"progress",style:(`--percentage: ${_vm.percentage}deg;`)},[_vm._m(0),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.percentage)+"%")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barOverflow"},[_c('div',{staticClass:"bar"})])
}]

export { render, staticRenderFns }